export default __webpack_public_path__ + "static/EverydayInsightFeature-6e2b5f395a470516e72fb383dff9042f.webp";